import { useCallback, useReducer } from "react";
import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";
import { ViewOptionStateEnum } from "../../components/contextual-app-bar/ViewOptionStateEnum";
import { SetPointGrouping } from "./AdminSetpointListUtils";


type AdminSetpointListStateType = {

    //groupID: number | undefined;
    groupingOption: SetPointGrouping;
    groupObjectType: eLynxObjectTypeEnum | undefined,
    viewOptionState: ViewOptionStateEnum;
    filterText: string;
    isDirty: boolean;
    selectedSetpoints: number[];
};

export const defaultState: AdminSetpointListStateType = {
    //groupID: undefined,
    groupObjectType: undefined,
    groupingOption: SetPointGrouping.AllAlarms,
    viewOptionState: ViewOptionStateEnum.Default,
    filterText: '',
    isDirty: false,
    selectedSetpoints: []
};


enum SetpointListStateActionEnum {
    GroupingChanged = 'SETPOINT_ADMIN_GROUPING_CHANGED',
    FilterTextChanged = 'SETPOINT_ADMIN_FILTER_TEXT_CHANGED',
    SelectedSetpointsChanged = 'SETPOINT_ADMIN_SELECTED_CHANGED',
    Reset = 'SETPOINT_ADMIN_RESET_CHANGED'

}


type SetpointListStateActionType = {
    type: SetpointListStateActionEnum.FilterTextChanged;
    payload: string;
} | {
    type: SetpointListStateActionEnum.GroupingChanged;
    payload: SetPointGrouping;
} | {
    type: SetpointListStateActionEnum.SelectedSetpointsChanged;
    payload: number[]
} | {
    type: SetpointListStateActionEnum.Reset;
    payload: void;
};


const optionsChanged = (newState: AdminSetpointListStateType, 
    defaultState: AdminSetpointListStateType) => 
    newState.groupingOption !== defaultState.groupingOption || 
    newState.filterText !== defaultState.filterText;


function reducer(state: AdminSetpointListStateType, action: SetpointListStateActionType): AdminSetpointListStateType {

    const copy = { ...state };
    switch (action.type) {

        case SetpointListStateActionEnum.Reset:
            return {...defaultState};

//        case SetpointListStateActionEnum.GroupChanged:
//            copy.groupID = action.payload;
//            return copy;

        case SetpointListStateActionEnum.FilterTextChanged:
            copy.filterText = action.payload;

            copy.viewOptionState = optionsChanged(copy, defaultState) ? 
                                    ViewOptionStateEnum.Changed : 
                                    ViewOptionStateEnum.Default;

            return copy;

        case SetpointListStateActionEnum.SelectedSetpointsChanged:
            copy.selectedSetpoints = [...action.payload];
            return copy;

        case SetpointListStateActionEnum.GroupingChanged:
            copy.groupingOption = action.payload;

            switch (copy.groupingOption) {
                case SetPointGrouping.DeviceAlarms:
                    copy.groupObjectType = eLynxObjectTypeEnum.Device;
                    break;

                case SetPointGrouping.TankAlarms:
                    copy.groupObjectType = eLynxObjectTypeEnum.Tank;
                    break;

                case SetPointGrouping.TankBatteryAlarms:
                    copy.groupObjectType = eLynxObjectTypeEnum.TankBattery;
                    break;
           
                case SetPointGrouping.WellAlarms:
                    copy.groupObjectType = eLynxObjectTypeEnum.Well;
                    break;

                default:
                    copy.groupObjectType = undefined;
        
            }

            copy.viewOptionState = optionsChanged(copy, defaultState) ? 
                                    ViewOptionStateEnum.Changed : 
                                    ViewOptionStateEnum.Default;

            return copy;


        default: return {...state};
    }
}

export default function useAdminSetpointListState() {
    const [state, dispatch] = useReducer(reducer, defaultState);

    const setFilterText = useCallback((value: string) => dispatch({
        type: SetpointListStateActionEnum.FilterTextChanged,
        payload: value
    }), []);

    const setGrouping = useCallback((value: SetPointGrouping) => dispatch({
        type: SetpointListStateActionEnum.GroupingChanged,
        payload: value
    }), []);

    const resetState = useCallback(() => dispatch({
        type: SetpointListStateActionEnum.Reset,
        payload: undefined
    }), []);

    const setSelectedSetpoints = useCallback((value: number[]) => dispatch({
        type: SetpointListStateActionEnum.SelectedSetpointsChanged,
        payload: value
    }), []);


    return {
        state,
        setFilterText,
        setGrouping,
        setSelectedSetpoints,
        resetState
    };
}    
